/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function NmWishlistIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6.529 0A6.386 6.386 0 001.91 1.974c-2.543 2.634-2.55 6.863-.01 9.5l10.175 10.563a.693.693 0 00.96 0C16.43 18.521 19.816 15 23.21 11.484c2.543-2.635 2.543-6.865 0-9.5a6.395 6.395 0 00-9.245 0L12.56 3.426l-1.405-1.452A6.306 6.306 0 006.53 0zm0 1.289c1.322 0 2.65.531 3.677 1.595l1.88 1.953a.693.693 0 00.96 0l1.87-1.943c2.054-2.127 5.291-2.127 7.345 0 2.053 2.127 2.053 5.563 0 7.69l-9.7 10.052-9.7-10.062c-2.051-2.13-2.053-5.563 0-7.69C3.889 1.82 5.208 1.289 6.53 1.289z"
                fill="currentColor"
            />
        </svg>
    );
}
